/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * CongratsText.ts - Text to use for congratulations messages
 */
export const WELL_DONE = 'Well Done!';
export const GREAT_JOB = 'Great Job!';
export const FANTASTIC = 'Fantastic!';
export const SUPER_WORK = 'Super Work!';
export const BRILLIANT = 'Brilliant!';

export const messages = [
  { message: WELL_DONE },
  { message: GREAT_JOB },
  { message: FANTASTIC },
  { message: SUPER_WORK },
  { message: BRILLIANT },
] as const;
